import * as yup from 'yup'

const CancelBuyerInvoiceSchem = yup.object().shape({
    cancelRemarks: yup.string().required('Select Reason for Cancel Invoice')
})


export { CancelBuyerInvoiceSchem  };